import type NumberUnit from '@exodus/currency';
import { isNumberUnit } from '@exodus/currency';
import { formatPrice } from '@exodus/formatting/lib/price';
import { createSelector } from 'reselect';

import selectors from '../../selectors.js';

const formatFiatSelector = createSelector(
  selectors.locale.currency,
  (currency: string) =>
    (
      fiatValue: string | number | NumberUnit,
      { customCurrency }: { customCurrency?: string } = {},
    ) => {
      const fiatCurrency = customCurrency || currency;
      const value = isNumberUnit(fiatValue)
        ? fiatValue.toDefaultNumber()
        : fiatValue;

      return formatPrice(value, {
        useGrouping: false,
        currency: fiatCurrency,
      });
    },
);

export default formatFiatSelector;
